import React from "react";

export const CurrentplanSkeleton = () => (
  <div className="current-plan-skeleton">
    {/* Plan name
    <div
      className="skeleton skeleton-title"
      style={{ width: "55%", height: "18px", borderRadius: "8px", marginBottom: "18px" }}
    /> */}

    {/* Price block */}
    <div style={{ display: "flex", alignItems: "baseline", gap: "8px", marginBottom: "10px" }}>
      <div
        className="skeleton"
        style={{ width: "110px", height: "36px", borderRadius: "8px" }}
      />
      <div
        className="skeleton"
        style={{ width: "50px", height: "14px", borderRadius: "6px" }}
      />
    </div>

    {/* Billing cycle meta */}
    <div
      className="skeleton skeleton-subtitle"
      style={{ width: "70%", height: "12px", borderRadius: "6px", marginBottom: "30px" }}
    />

    {/* Action button */}
    <div
      className="skeleton"
      style={{ width: "130px", height: "36px", borderRadius: "10px" }}
    />
  </div>
);

export const CurrentPlanProtag = () => (
  <div
    className="skeleton"
    style={{ width: "70px", height: "24px", borderRadius: "10px" }}
  />
);